import enumeration from "./enumeration";

const SubscriptionStatus = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
};

export default enumeration(SubscriptionStatus);
